import {
  NormalRow,
  IndentedRow,
  StartRow,
  EndRow,
  DetailRow,
  ExpandableIndentedRow,
  IndentedDetailRow,
} from '../TableRows';

/**
 * rowComponents
 *
 * This dictionary maps each row type to its corresponding component.
 * The Table component looks up the appropriate row type here and renders it
 * accordingly (e.g., normal, indented, start, end, detail).
 */
const rowComponents = {
  normal: NormalRow,
  indented: IndentedRow,
  start: StartRow,
  end: EndRow,
  detail: DetailRow,
  expandableEvent: ExpandableIndentedRow,
  indentedDetail: IndentedDetailRow,
};

export default rowComponents;
